/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import Peripherals from '@appblocks/codegeneration/Peripherals';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: CodeBlock[] = [];

    const project = feature.project;
    const NAME = feature.getSettingValue('NAME');
    let PORT = feature.getSettingValue('PORT');
    if (PORT.indexOf('/') === 0) {
        PORT = `{${PORT}}`;
    }
    const SERVO_PERIOD = feature.getSettingValue('SERVO_PERIOD');
    const PIN = feature.getSettingValue('PIN');
    const device = PlatformUtils.getDeviceDefinition(feature.project.device.id);
    if (!PIN) {
        return blocks;
    }
    const dtsName = `${NAME.toLowerCase()}_servo`;
    let pwmIndex = 0;

    // find pwm index;
    for (let i = 0; i < project.features.length; i++) {
        const tmpFeature = project.features[i];
        if (tmpFeature.id === 'pwm' || tmpFeature.id === 'servo') {
            if (tmpFeature.getID() === feature.getID()) {
                break;
            }
            pwmIndex++;
        }
    }

    const GPIO = Peripherals.getGPIOPeripheral(PIN, project.device.id);

    blocks.push({
        location: 'PRJ_CONF',
        id: 'CONFIG_PWM=y',
        blockType: BlockType.CODE,
        template: `
CONFIG_PWM=y`,
    });

    blocks.push({
        location: 'GLOBAL_INCLUDES',
        id: '#include <zephyr/drivers/pwm.h>',
        blockType: BlockType.CODE,
        template: `
#include <zephyr/drivers/pwm.h>`,
    });

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
static const struct pwm_dt_spec ${dtsName} = PWM_DT_SPEC_GET(DT_NODELABEL(${dtsName}));
`,
    });

    blocks.push({
        location: 'APP_OVERLAY_DTS',
        id: 'PWM_LEDS',
        blockType: BlockType.CODE,
        template: `
pwmleds {
    compatible = "pwm-leds";
    /****PWM_LEDS****/
};`,
    });

    if (device.soc.indexOf('esp') === 0) {
        blocks.push({
            location: 'APP_OVERLAY',
            id: 'ledc0',
            blockType: BlockType.CODE,
            template: `
&ledc0 {
    pinctrl-0 = <&ledc0_default>;
    pinctrl-names = "default";
    status = "okay";
    #address-cells = <1>;
    #size-cells = <0>;
    /****ledc0****/
};
`,
        });

        blocks.push({
            location: 'APP_OVERLAY_INCLUDES',
            id: '#include <zephyr/dt-bindings/pwm/pwm.h>',
            blockType: BlockType.CODE,
            template: `
#include <zephyr/dt-bindings/pwm/pwm.h>
`,
        });

        blocks.push({
            location: 'PWM_LEDS',
            blockType: BlockType.CODE,
            template: `
${dtsName}: ${dtsName} {
    label = "${NAME}";
    pwms = <&ledc0 ${pwmIndex} PWM_MSEC(20) PWM_POLARITY_NORMAL>;
};`,
        });

        blocks.push({
            location: 'ledc0',
            blockType: BlockType.CODE,
            template: `
channel${pwmIndex}@${pwmIndex} {
    reg = <0x${pwmIndex}>;
    timer = <${pwmIndex}>;
};
`,
        });

        blocks.push({
            location: 'APP_OVERLAY_PINCTRL',
            id: 'ledc0_default',
            blockType: BlockType.CODE,
            template: `
ledc0_default: ledc0_default {
    /****ledc0_default****/
};
`,
        });

        blocks.push({
            location: 'ledc0_default',
            blockType: BlockType.CODE,
            template: `
group${pwmIndex} {
    pinmux = <LEDC_CH${pwmIndex}_GPIO${GPIO.num}>;
    output-enable;
};
`,
        });
    }

    blocks.push({
        location: `var_${SERVO_PERIOD}_set`,
        blockType: BlockType.CODE,
        template: `
pwm_set_pulse_dt(&${dtsName}, PWM_USEC(value));
`,
    });

    return blocks;
};
